import { withRouter } from 'react-router';
import BalloonSelect from './BalloonSelect';

export default withRouter(BalloonSelect);
